"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ARIARole;
(function (ARIARole) {
    ARIARole["ALERT"] = "alert";
    ARIARole["ALERT_DIALOG"] = "alertdialog";
    ARIARole["APPLICATION"] = "application";
    ARIARole["ARTICLE"] = "article";
    ARIARole["ASSOCIATION_LIST"] = "associationlist";
    ARIARole["ASSOCIATION_LIST_ITEM_KEY"] = "associationlistitemkey";
    ARIARole["ASSOCIATION_LIST_ITEM_VALUE"] = "associationlistitemvalue";
    ARIARole["BANNER"] = "banner";
    ARIARole["BLOCK_QUOTE"] = "blockquote";
    ARIARole["BUTTON"] = "button";
    ARIARole["CAPTION"] = "caption";
    ARIARole["CELL"] = "cell";
    ARIARole["CHECKBOX"] = "checkbox";
    ARIARole["CODE"] = "code";
    ARIARole["COMBO_BOX"] = "combobox";
    ARIARole["COLUMN_HEADER"] = "columnheader";
    ARIARole["COMMENT"] = "comment";
    ARIARole["COMPLEMENTARY"] = "complementary";
    ARIARole["CONTENT_INFO"] = "contentinfo";
    ARIARole["DEFINITION"] = "definition";
    ARIARole["DELETION"] = "deletion";
    ARIARole["DIRECTORY"] = "directory";
    ARIARole["DIALOG"] = "dialog";
    ARIARole["DOCUMENT"] = "document";
    ARIARole["EMPHASIS"] = "emphasis";
    ARIARole["FEED"] = "feed";
    ARIARole["FIGURE"] = "figure";
    ARIARole["FORM"] = "form";
    ARIARole["GRID"] = "grid";
    ARIARole["GRID_CELL"] = "gridcell";
    ARIARole["GROUP"] = "group";
    ARIARole["HEADING"] = "heading";
    ARIARole["IMG"] = "img";
    ARIARole["INSERTION"] = "insertion";
    ARIARole["LIST"] = "list";
    ARIARole["LIST_BOX"] = "listbox";
    ARIARole["LIST_ITEM"] = "listitem";
    ARIARole["LOG"] = "log";
    ARIARole["MAIN"] = "main";
    ARIARole["MARK"] = "mark";
    ARIARole["MARQUEE"] = "marquee";
    ARIARole["MATH"] = "math";
    ARIARole["MENU_BAR"] = "menubar";
    ARIARole["METER"] = "meter";
    ARIARole["NAVIGATION"] = "navigation";
    ARIARole["NONE"] = "none";
    ARIARole["PARAGRAPH"] = "paragraph";
    ARIARole["PRESENTATION"] = "presentation";
    ARIARole["PROGRESS_BAR"] = "progressbar";
    ARIARole["OPTION"] = "option";
    ARIARole["REGION"] = "region";
    ARIARole["ROW"] = "row";
    ARIARole["ROW_GROUP"] = "rowgroup";
    ARIARole["ROW_HEADER"] = "rowheader";
    ARIARole["SCROLL_BAR"] = "scrollbar";
    ARIARole["SEARCH"] = "search";
    ARIARole["SEARCH_BOX"] = "searchbox";
    ARIARole["SEPARATOR"] = "separator";
    ARIARole["SLIDER"] = "slider";
    ARIARole["SPIN_BUTTON"] = "spinbutton";
    ARIARole["STATUS"] = "status";
    ARIARole["STRONG"] = "strong";
    ARIARole["SUB_SCRIPT"] = "subscript";
    ARIARole["SUPER_SCRIPT"] = "superscript";
    ARIARole["SUGGESTION"] = "suggestion";
    ARIARole["SWITCH"] = "switch";
    ARIARole["TAB"] = "tab";
    ARIARole["TABLE"] = "table";
    ARIARole["TAB_LIST"] = "tablist";
    ARIARole["TAB_PANEL"] = "tabpanel";
    ARIARole["TERM"] = "term";
    ARIARole["TEXT_BOX"] = "textbox";
    ARIARole["TIME"] = "time";
    ARIARole["TIMER"] = "timer";
    ARIARole["TOOLBAR"] = "toolbar";
    ARIARole["TOOLTIP"] = "tooltip";
    ARIARole["TREE"] = "tree";
    ARIARole["TREE_GRID"] = "treegrid";
    ARIARole["TREE_ITEM"] = "treeitem";
})(ARIARole || (ARIARole = {}));
exports.default = ARIARole;
//# sourceMappingURL=ARIARole.js.map